import { render, staticRenderFns } from "./DatatableEditNames.vue?vue&type=template&id=263364d8"
import script from "./DatatableEditNames.vue?vue&type=script&lang=js"
export * from "./DatatableEditNames.vue?vue&type=script&lang=js"
import style0 from "./DatatableEditNames.vue?vue&type=style&index=0&id=263364d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports